"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSVFormImportControl = exports.CSS = void 0;
const tslib_1 = require("tslib");
const core_shared_1 = require("@ikegps/core-shared");
const mobx_1 = require("mobx");
const input_select_1 = require("../../components/input/input.select");
const mithril_component_1 = require("../../components/mithril.component");
const spinner_1 = require("../../components/spinner/spinner");
const theme_1 = require("../../components/theme");
const i18n_1 = require("../../i18n");
const mithril_1 = require("../../mithril");
const trigger_1 = require("../../services/util/trigger");
const store_1 = require("../../store");
exports.CSS = {
    container: 'c-ImportMapper',
    spinner: 'c-ImportMapper__spinner',
    header: 'c-ImportMapper__header',
    body: 'c-ImportMapper__body',
    isInvalid: 'c-ImportMapper--invalid'
};
(0, theme_1.addStyles)({
    [exports.CSS.spinner]: {
        margin: 'auto',
        padding: theme_1.DefaultTheme.space(2),
        display: 'flex',
        'justify-content': 'center'
    },
    [exports.CSS.container]: {
        padding: '8px',
        width: '100%',
        'table-layout': 'fixed',
        'font-family': theme_1.DefaultTheme.font.familyCondensed
    },
    [exports.CSS.body + ' td']: {
        padding: theme_1.DefaultTheme.space(1),
        'max-width': 0,
        overflow: 'hidden',
        'min-width': 0,
        'white-space': 'nowrap',
        'text-overflow': 'ellipsis'
    },
    [exports.CSS.isInvalid]: {
        color: 'red'
    }
});
class CSVFormImportControl extends mithril_component_1.IMithrilStateComponent {
    constructor() {
        super(...arguments);
        this.trigger = new trigger_1.IkeTrigger('CSVImport');
        this.data = null;
        this.form = null;
        this.mappings = [];
        this.isLoading = false;
        this.isValid = false;
    }
    setLoaded() {
        this.isValid = this.mapper.isValid;
        this.isLoading = false;
    }
    get collections() {
        return (this.mapper != null && this.mapper.processed) || [];
    }
    process(formId, data) {
        if (!data.isValid) {
            throw new Error('Invalid CSV given');
        }
        this.isLoading = true;
        this.formId = formId;
        this.data = data;
        this.loadFormAndProcess();
    }
    loadFormAndProcess() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const form = yield store_1.AppStore.Form.fetch(this.formId);
            this.form = form;
            this.mapper = new core_shared_1.IkeCSVMapper(this.data, form);
            this.mapper.setDefaultMappings();
            this.mappings = [];
            for (const mapping of this.mapper.mappings) {
                const displayName = mapping.fieldKey ? mapping.field.displayName + ' ' + (0, i18n_1.Translate)(mapping.fieldKey.toUpperCase()) : mapping.field.displayName;
                const selection = new input_select_1.SelectInputState(displayName);
                this.reaction(() => selection.value, headerKey => this.setMapping(mapping, headerKey));
                for (const header of this.data.headers) {
                    selection.addOption({ key: header, value: header });
                }
                selection._value = this.data.headers[mapping.csvIndex] || null;
                this.mappings.push({ mapping, selection });
            }
            this.setLoaded();
        });
    }
    get nodes() {
        if (this.isLoading || this.form == null) {
            return (0, mithril_1.m)('div', { className: exports.CSS.spinner }, spinner_1.Spinner.view());
        }
        this.trigger.observe();
        return (0, mithril_1.m)('table', { className: exports.CSS.container }, [
            (0, mithril_1.m)('thead', { className: exports.CSS.header }, this.mappings.map(h => (0, mithril_1.m)('th', input_select_1.SelectInputComponent.view(h.selection)))),
            (0, mithril_1.m)('tbody', { className: exports.CSS.body }, this.collections.map((r, i) => this.viewRow(i)))
        ]);
    }
    viewRow(index) {
        const children = [];
        let hasValue = false;
        for (const mapping of this.mappings) {
            if (mapping == null || mapping.selection.value == null) {
                children.push((0, mithril_1.m)('td'));
            }
            else {
                hasValue = true;
                const mappedValue = this.mapper.getCollectionValue(mapping.mapping, index);
                if (mappedValue.isValid) {
                    children.push((0, mithril_1.m)('td', mappedValue.value));
                }
                else {
                    this.isValid = false;
                    children.push((0, mithril_1.m)('td', { className: exports.CSS.isInvalid, title: (0, i18n_1.Translate)(i18n_1.T.COLLECTION_IMPORT_FIELD_INVALID, { field: mapping.mapping.field.displayName }) }, mappedValue.raw));
                }
            }
        }
        if (hasValue) {
            return (0, mithril_1.m)('tr', {}, children);
        }
        return null;
    }
    setMapping(mapping, csvHeader) {
        const headerIndex = this.data.getHeaderIndex(csvHeader);
        this.mapper.setMapping(mapping, headerIndex);
        this.isValid = this.mapper.isValid;
        // Force a redraw
        this.trigger.trigger();
    }
    reset() {
        this.formId = null;
        this.data = null;
        this.isLoading = true;
        this.isValid = false;
        this.mappings = [];
    }
}
exports.CSVFormImportControl = CSVFormImportControl;
tslib_1.__decorate([
    mobx_1.observable
], CSVFormImportControl.prototype, "formId", void 0);
tslib_1.__decorate([
    mobx_1.observable
], CSVFormImportControl.prototype, "isLoading", void 0);
tslib_1.__decorate([
    mobx_1.observable
], CSVFormImportControl.prototype, "isValid", void 0);
tslib_1.__decorate([
    mobx_1.action
], CSVFormImportControl.prototype, "setLoaded", null);
tslib_1.__decorate([
    mobx_1.action
], CSVFormImportControl.prototype, "process", null);
tslib_1.__decorate([
    mobx_1.action
], CSVFormImportControl.prototype, "setMapping", null);
tslib_1.__decorate([
    mobx_1.action
], CSVFormImportControl.prototype, "reset", null);
//# sourceMappingURL=import.ctrl.js.map